import { Navigate, useSearchParams } from 'react-router-dom';

import { paths } from '@/app/router/paths';
import { useUser } from '@/features/auth/hooks/use-user';

export const PublicRoute = ({ children }: { children: React.ReactNode }) => {
  const user = useUser();
  const [searchParams] = useSearchParams();

  if (user.isLoading) {
    return <div>Loading...</div>;
  }

  if (user.error) {
    return <div>Error loading user data</div>;
  }

  if (user.data && user.data.email_confirmed_at) {
    // Only redirect users who have confirmed their email

    const currentRedirectTo = searchParams.get('redirectTo');
    return <Navigate to={currentRedirectTo || paths.dashboard.path} replace />;
  }

  return <>{children}</>;
};
